export const actionTypes = {
  CREATE: 'יצירה',
  EDIT: 'עריכה',
  DELETE: 'מחיקה',
  UPLOAD: 'העלאה'
}

export const actionTypesUsersClient = {
  GENERAL: 'כללי',
  PAYMENTS: 'תשלומים',
  INVOICES: 'חשבוניות'
}